import React, {useState, useContext, useEffect} from 'react';
import {Context} from '../../Helpers/Auth';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import Pipeline from '../../components/Negocios/Pipeline';
import DrawerFilter from '../../components/Negocios/DrawerFilter';
import NovoNegocio from '../../components/Negocios/NovoNegocio';
import ViewKanbanOutlinedIcon from '@mui/icons-material/ViewKanbanOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import Listagem from '../../components/Negocios/Listagem';
import EditCalendarRoundedIcon from '@mui/icons-material/EditCalendarRounded';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';

import Agendamentos from '../../components/Negocios/Agendamentos';
import {KanbanProvider} from '../../components/Negocios/Pipeline/Context/index.js';
import SensorOccupiedRoundedIcon from '@mui/icons-material/SensorOccupiedRounded';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import WorkspacesOutlinedIcon from '@mui/icons-material/WorkspacesOutlined';
import Propostas from '../../components/Negocios/Propostas/index.js';
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';

import {getDados, getRepresentantes} from '../../pages/requests';

function Negocios(color) {
    const {t} = useTranslation();

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES';
    }

    // Apresenta form de megocio ou não
    const [showForm, setShowForm] = useState(false);

    // Separador do form que está visivel
    const [openTab, setOpenTab] = React.useState(1);

    // Indica se o form está em modo de edição ou não
    const [editarNegocio, setEditarNegocio] = useState(false);

    // Negocio que está selecionado
    const [negocioSelecionado, setNegocioSelecionado] = useState(null);

    // Flag a indicar que foram feitas alterações no formulario
    const [onChangeForm, setOnChangeForm] = useState(false);

    //Flag a indicar que foi clicado no botão de gravar
    const [guardar, setGuardar] = useState(false);

    // flag a indicar que foi clicado no botão de nova visita/reuniao/interação
    const [novoAgendamento, setNovoAgendamento] = useState(false);

    // flag a indicar que foi clicado no botão de nova proposta
    const [novaProposta, setNovaProposta] = useState(false);

    const [kanban, setKanban] = useState(false);
    const [consulta, setConsulta] = useState(false);
    const {path, setPath} = useContext(Context);

    const history = useHistory();

    // flag para indicar se o negocio aberto tem contrato de manutenção
    const [contratoManutencao, setContratoManutencao] = useState(false);
    // flag para indicar se o negocio aberto tem contrato financeiro
    const [contratoFinanceiro, setContratoFinanceiro] = useState(false);

    useEffect(() => {
        if (showForm === false) {
            setContratoManutencao(false);
            setContratoFinanceiro(false);
        }
    }, [showForm]);
    /////////////////////////////////////////////////////////////////
    //
    // TODO
    // Limpar variaveis para novos registos
    //
    //
    /////////////////////////////////////////////////////////////////
    const [etapas, setEtapas] = useState([]);
    const [responsaveis, setResponsaveis] = useState([]);
    // filtros
    const [filtroEstado, setFiltroEstado] = useState('');
    const [filtroPotencial, setFiltroPotencial] = useState(0);

    const [filtroCategoria, setFiltroCategoria] = useState(null);
    const [filtroMarca, setFiltroMarca] = useState(null);
    const [filtroNacionalInternacional, setFiltroNacionalInternacional] = useState(null);
    const [filtroFamilia, setFiltroFamilia] = useState('');

    const [filtroRep, setFiltroRep] = useState([]);

    // Filtros tabela
    const [filtroNome, setFiltroNome] = useState('');
    const [filtroCodigo, setFiltroCodigo] = useState('');
    const [filtroEtapa, setFiltroEtapa] = useState([]);
    const [filtroEmpresa, setFiltroEmpresa] = useState('');
    const [filtroDt, setFiltroDt] = useState({startDate: null, endDate: null});
    const [filtroStatusDt, setFiltroStatusDt] = useState({startDate: null, endDate: null});
    const [filtroValor, setFiltroValor] = useState(0);

    const handleRowClick = dados => {
        setNegocioSelecionado(dados);
        setShowForm(true);
    };
console.log(history.location, "aqui");
    useEffect(() => {
        if (negocioSelecionado != null && showForm) {
            setPath(t('editarNegocio') + ' ' + negocioSelecionado.num + '-' + negocioSelecionado.nome);
        } else if (showForm && negocioSelecionado == null) {
            setPath(t('criarNegocio'));
        } else {
            setPath('');
        }
    }, [path, negocioSelecionado, showForm]);

    useEffect(() => {
        if (history.location.state?.negocio) {
            setShowForm(true);
            setOpenTab(3);
            setNegocioSelecionado(history.location.state?.negocio);
            return;
        }

        if (history.location.state?.proposta) {
            setShowForm(true);
            setEditarNegocio(true);
            setOpenTab(3);
            setNegocioSelecionado(history.location.state?.proposta)
            return;
        }
        if (history.location.state?.prospect) {
            setShowForm(true);
            setEditarNegocio(true);
            setOpenTab(3);
            // setNegocioSelecionado(history.location.state?.prospect)
            return;
        }
    }, [history]);

    useEffect(() => {
        getDados(lang).then(res => {
            setEtapas(res.data.etapas);
        });
        getRepresentantes(lang).then(res => {
            setResponsaveis(res.data.representantes);
        });
    }, []);



    return (
        <>
            <div className="border-b mb-5 border-gray-200 dark:border-gray-600">
                <div
                    className="flex flex-wrap items-center justify-between -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400"
                    role="tablist"
                    id="myTab"
                    data-tabs-toggle="#myTabContent">
                    <div className="flex space-x-2">
                        {!showForm && (
                            <div>
                                <button
                                    aria-controls="agenda"
                                    id="agenda-tab"
                                    type="button"
                                    data-toggle="tab"
                                    href="#link1"
                                    role="tablist"
                                    aria-current="page"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 1
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(1);
                                    }}>
                                    <ViewKanbanOutlinedIcon className="mr-2" />
                                    {t('pipeline')}
                                </button>

                                <button
                                    aria-controls="calendario"
                                    id="calendario-tab"
                                    data-toggle="tab"
                                    href="#link2"
                                    role="tablist"
                                    type="button"
                                    // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 2
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(2);
                                    }}>
                                    <ListAltOutlinedIcon className="mr-2" />
                                    {t('listagem')}
                                </button>
                            </div>
                        )}
                        {showForm && (
                            <div>
                                <button
                                    aria-controls="agenda"
                                    id="agenda-tab"
                                    type="button"
                                    data-toggle="tab"
                                    href="#link1"
                                    role="tablist"
                                    aria-current="page"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 3
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(3);
                                    }}>
                                    <TextSnippetOutlinedIcon className="mr-2" />
                                    {t('dadosBase')}
                                </button>

                                <button
                                    aria-controls="calendario"
                                    id="calendario-tab"
                                    data-toggle="tab"
                                    href="#link2"
                                    role="tablist"
                                    type="button"
                                    // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 10
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(10);
                                    }}>
                                    <WorkspacesOutlinedIcon className="mr-2" />
                                    {t('equipamentos')}
                                </button>
                                <button
                                    aria-controls="calendario"
                                    id="calendario-tab"
                                    data-toggle="tab"
                                    href="#link2"
                                    role="tablist"
                                    type="button"
                                    // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 6
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(6);
                                    }}>
                                    <SensorOccupiedRoundedIcon className="mr-2" />
                                    {t('concorrentes')}
                                </button>
                                <button
                                    aria-controls="agenda"
                                    id="agenda-tab"
                                    type="button"
                                    data-toggle="tab"
                                    href="#link1"
                                    role="tablist"
                                    aria-current="page"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 7
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(7);
                                    }}>
                                    <BarChartRoundedIcon className="mr-2" />
                                    {t('status')}
                                </button>
                                {contratoManutencao && (
                                    <button
                                        aria-controls="agenda"
                                        id="agenda-tab"
                                        type="button"
                                        data-toggle="tab"
                                        href="#link1"
                                        role="tablist"
                                        aria-current="page"
                                        className={
                                            'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                            (openTab === 11
                                                ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                        }
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(11);
                                        }}>
                                        <FileOpenOutlinedIcon className="mr-2" />
                                        {t('contratoManutencao')}
                                    </button>
                                )}
                                {contratoFinanceiro && (
                                    <button
                                        aria-controls="agenda"
                                        id="agenda-tab"
                                        type="button"
                                        data-toggle="tab"
                                        href="#link1"
                                        role="tablist"
                                        aria-current="page"
                                        className={
                                            'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                            (openTab === 12
                                                ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                        }
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(12);
                                        }}>
                                        <FileOpenOutlinedIcon className="mr-2" />
                                        {t('contratoFinanceiro')}
                                    </button>
                                )}
                            </div>
                        )}
                        {showForm && negocioSelecionado && (
                            <div>
                                <button
                                    aria-controls="calendario"
                                    id="calendario-tab"
                                    data-toggle="tab"
                                    href="#link4"
                                    role="tablist"
                                    type="button"
                                    // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 4
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(4);
                                    }}>
                                    <EditCalendarRoundedIcon className="mr-2" />
                                    {t('agendamentos')}
                                </button>
                            </div>
                        )}
                        {showForm && negocioSelecionado && (
                            <div>
                                <button
                                    aria-controls="calendario"
                                    id="calendario-tab"
                                    data-toggle="tab"
                                    href="#link2"
                                    role="tablist"
                                    type="button"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 5
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(5);
                                    }}>
                                    <PostAddOutlinedIcon className="mr-2" />
                                    {t('propostas')}
                                </button>
                            </div>
                        )}
                    </div>

                    <DrawerFilter
                        openTab={openTab}
                        responsaveis={responsaveis}
                        etapas={etapas}
                        showForm={showForm}
                        setShowForm={setShowForm}
                        setOpenTab={setOpenTab}
                        setEditarNegocio={setEditarNegocio}
                        editarNegocio={editarNegocio}
                        setNegocioSelecionado={setNegocioSelecionado}
                        negocioSelecionado={negocioSelecionado}
                        setOnChangeForm={setOnChangeForm}
                        onChangeForm={onChangeForm}
                        setGuardar={setGuardar}
                        setNovoAgendamento={setNovoAgendamento}
                        setNovaProposta={setNovaProposta}
                        filtroEstado={filtroEstado}
                        setFiltroEstado={setFiltroEstado}
                        setFiltroRep={setFiltroRep}
                        filtroRep={filtroRep}
                        setFiltroPotencial={setFiltroPotencial}
                        filtroPotencial={filtroPotencial}
                        //
                        setFiltroCategoria={setFiltroCategoria}
                        filtroCategoria={filtroCategoria}
                        setFiltroMarca={setFiltroMarca}
                        filtroMarca={filtroMarca}
                        setFiltroNacionalInternacional={setFiltroNacionalInternacional}
                        filtroNacionalInternacional={filtroNacionalInternacional}
                        setFiltroFamilia={setFiltroFamilia}
                        filtroFamilia={filtroFamilia}
                        //
                        filtroEmpresa={filtroEmpresa}
                        setFiltroEmpresa={setFiltroEmpresa}
                        setFiltroNome={setFiltroNome}
                        filtroNome={filtroNome}
                        filtroCodigo={filtroCodigo}
                        setFiltroCodigo={setFiltroCodigo}
                        filtroEtapa={filtroEtapa}
                        setFiltroEtapa={setFiltroEtapa}
                        filtroDt={filtroDt}
                        setFiltroStatusDt={setFiltroStatusDt}
                        filtroStatusDt={filtroStatusDt}
                        setFiltroDt={setFiltroDt}
                        filtroValor={filtroValor}
                        setFiltroValor={setFiltroValor}
                    />
                </div>
            </div>
            <div id="myTabContent">
                {!showForm && openTab === 1 && (
                    <div id="link1">
                        <KanbanProvider>
                            <Pipeline
                                onRowClick={handleRowClick}
                                kanban={kanban}
                                setKanban={setKanban}
                                consulta={consulta}
                                setConsulta={setConsulta}
                                filtroMarca={filtroMarca}
                                setFiltroMarca={setFiltroMarca}
                                filtroPotencial={filtroPotencial}
                                setFiltroPotencial={setFiltroPotencial}
                                filtroRep={filtroRep}
                                setFiltroRep={setFiltroRep}
                                filtroEstado={filtroEstado}
                                setFiltroEstado={setFiltroEstado}
                                filtroNome={filtroNome}
                                setFiltroNome={setFiltroNome}
                                filtroCodigo={filtroCodigo}
                                setFiltroCodigo={setFiltroCodigo}
                                filtroEtapa={filtroEtapa}
                                setFiltroEtapa={setFiltroEtapa}
                                filtroFamilia={filtroFamilia}
                                filtroEmpresa={filtroEmpresa}
                                setFiltroEmpresa={setFiltroEmpresa}
                                setFiltroFamilia={setFiltroFamilia}
                                filtroDt={filtroDt}
                                setFiltroDt={setFiltroDt}
                                setFiltroStatusDt={setFiltroStatusDt}
                                filtroStatusDt={filtroStatusDt}
                                filtroValor={filtroValor}
                                setFiltroValor={setFiltroValor}
                                setOpenTab={setOpenTab}
                                setEditarNegocio={setEditarNegocio}
                                filtroCategoria={filtroCategoria}
                                filtroNacionalInternacional={filtroNacionalInternacional}
                            />
                        </KanbanProvider>
                    </div>
                )}
                {!showForm && openTab === 2 && (
                    <div id="link2">
                        <Listagem
                            responsaveis={responsaveis}
                            etapas={etapas}
                            openTab={openTab}
                            setOpenTab={setOpenTab}
                            onRowClick={handleRowClick}
                            setEditarNegocio={setEditarNegocio}
                            kanban={kanban}
                            setKanban={setKanban}
                            consulta={consulta}
                            setConsulta={setConsulta}
                            filtroPotencial={filtroPotencial}
                            setFiltroPotencial={setFiltroPotencial}
                            filtroRep={filtroRep}
                            setFiltroRep={setFiltroRep}
                            filtroEstado={filtroEstado}
                            setFiltroEstado={setFiltroEstado}
                            filtroNome={filtroNome}
                            setFiltroNome={setFiltroNome}
                            filtroCodigo={filtroCodigo}
                            setFiltroCodigo={setFiltroCodigo}
                            filtroEtapa={filtroEtapa}
                            setFiltroEtapa={setFiltroEtapa}
                            filtroEmpresa={filtroEmpresa}
                            setFiltroEmpresa={setFiltroEmpresa}
                            filtroDt={filtroDt}
                            setFiltroDt={setFiltroDt}
                            setFiltroStatusDt={setFiltroStatusDt}
                            filtroStatusDt={filtroStatusDt}
                            filtroValor={filtroValor}
                            setFiltroValor={setFiltroValor}
                            //
                            setFiltroCategoria={setFiltroCategoria}
                            filtroCategoria={filtroCategoria}
                            setFiltroMarca={setFiltroMarca}
                            filtroMarca={filtroMarca}
                            setFiltroNacionalInternacional={setFiltroNacionalInternacional}
                            filtroNacionalInternacional={filtroNacionalInternacional}
                            setFiltroFamilia={setFiltroFamilia}
                            filtroFamilia={filtroFamilia}
                        />
                    </div>
                )}

                {/* separador de listagem de interações para o negocio */}
                {showForm && openTab === 4 && (
                    <div id="link4">
                        <Agendamentos
                            setNovoAgendamento={setNovoAgendamento}
                            novoAgendamento={novoAgendamento}
                            negocio={negocioSelecionado}
                            setOpenTab={setOpenTab}
                            onRowClick={handleRowClick}
                            setEditarNegocio={setEditarNegocio}
                        />
                    </div>
                )}

                {/* separador de listagem de interações para o negocio */}
                {showForm && openTab === 5 && (
                    <div id="link5">
                        <Propostas
                            setNovoAgendamento={setNovoAgendamento}
                            novoAgendamento={novoAgendamento}
                            negocio={negocioSelecionado}
                            setOpenTab={setOpenTab}
                            onRowClick={handleRowClick}
                            setEditarNegocio={setEditarNegocio}
                        />
                    </div>
                )}

                {showForm && (
                    <NovoNegocio
                        onChangeForm={onChangeForm}
                        novoAgendamento={novoAgendamento}
                        setNovoAgendamento={setNovoAgendamento}
                        negocio={negocioSelecionado}
                        setGuardar={setGuardar}
                        guardar={guardar}
                        showForm={showForm}
                        setOnChangeForm={setOnChangeForm}
                        editarNegocio={editarNegocio}
                        openTab={openTab}
                        setNovaProposta={setNovaProposta}
                        novaProposta={novaProposta}
                        setContratoManutencao={setContratoManutencao}
                        contratoManutencao={contratoManutencao}
                        setContratoFinanceiro={setContratoFinanceiro}
                        contratoFinanceiro={contratoFinanceiro}
                        setOpenTab={setOpenTab}
                        setShowForm={setShowForm}
                        setEditarNegocio={setEditarNegocio}
                    />
                )}
            </div>
        </>
    );
}

export default Negocios;
